exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-selection-required-overlay{position:fixed;top:calc(3.5em + 40px + var(--email-header-offset, 0px));left:0;width:100%;bottom:0;background-color:rgba(0,0,0,.5);z-index:29}.store-selection-required-content{width:100%;height:100%;background:#fff;padding:24px;box-sizing:border-box}", ""]);

// exports
